import { Tooltip } from '@material-ui/core';
import React from 'react';
import { IDeliveryVariables } from '~/src/dash/apiV2/forecasting/forecasting';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, spacing, TextInput } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  deliveryVariables: IDeliveryVariables;
}

export const AdjustmentToTraffic = ({ deliveryVariables }: IProps): JSX.Element => {
  return (
    <Cols gap={spacing.base} style={{ alignItems: 'center' }}>
      <Col>
        <TextInput
          width='52px'
          placeholder=' %'
          msDelay={500}
          initialValue={String(deliveryVariables.TrafficAdjustment || '')}
          handleOnChange={(value: string) => {
            deliveryVariables.TrafficAdjustment = parseInt(value, 10);
          }}
        />
      </Col>
      <Col>
        <Tooltip
          title='Enter your assumptions about expected changes in overall supply. Use a value above or below 100 to adjust traffic: for example, inputting 90 will decrease total supply to 90%, while entering 130 will increase it by 30%.'
          placement='top'
        >
          <div style={{ display: 'flex' }}>
            <IconV2 large name='info-static' color={publicaColors.gray} />
          </div>
        </Tooltip>
      </Col>
    </Cols>
  );
};
